/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./drop.down.item.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./drop.down.item.component";
import * as i3 from "../drop.down.component";
import * as i4 from "../item.group/drop.down.item.group.component";
var styles_DropDownItemComponent = [i0.styles];
var RenderType_DropDownItemComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_DropDownItemComponent, data: {} });
export { RenderType_DropDownItemComponent as RenderType_DropDownItemComponent };
export function View_DropDownItemComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_DropDownItemComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ig-drop-down-item", [], null, [[null, "click"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1).onClick($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_DropDownItemComponent_0, RenderType_DropDownItemComponent)), i1.ɵdid(1, 49152, null, 0, i2.DropDownItemComponent, [i3.DropDownComponent, [2, i4.DropDownItemGroupComponent]], null, null)], null, null); }
var DropDownItemComponentNgFactory = i1.ɵccf("ig-drop-down-item", i2.DropDownItemComponent, View_DropDownItemComponent_Host_0, {}, {}, ["*"]);
export { DropDownItemComponentNgFactory as DropDownItemComponentNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/drop.down/item/drop.down.item.component.ngfactory.js.pre-build-optimizer.js